import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ChartProps } from '@app-types/visualization';

const DEFAULT_COLORS = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#06b6d4'];

const StackedBarChart: React.FC<ChartProps> = ({ 
  data, 
  config, 
  colors = DEFAULT_COLORS, 
  height = 350 
}) => {
  if (!data || data.length === 0) {
    return <div>No data available</div>;
  }

  // Get chart configuration
  const xAxisColumn = config?.xAxis?.column || Object.keys(data[0])[0];
  const primaryColumns = config?.yAxis?.primary?.columns || [];
  const primaryLabels = config?.yAxis?.primary?.labels || primaryColumns;

  // Fallback: auto-detect numeric columns if not configured
  const stackColumns = primaryColumns.length > 0 ? primaryColumns : 
    Object.keys(data[0]).filter(k => k !== xAxisColumn && typeof data[0][k] === 'number');

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis 
          dataKey={xAxisColumn}
          angle={-45}
          textAnchor="end"
          height={80}
          fontSize={12}
        />
        <YAxis fontSize={12} />
        <Tooltip />
        <Legend />
        {stackColumns.map((column, index) => (
          <Bar 
            key={column}
            dataKey={column} 
            stackId="stack"
            fill={colors[index % colors.length]}
            name={primaryLabels[index] || column.replace(/_/g, ' ')}
          />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
};

export default StackedBarChart; 